import React, { Fragment } from 'react';
import { List, Map } from 'immutable';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Grid from '@material-ui/core/Grid';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import { Field, MuiRadioGroup } from '../../../common/form';
import QuestionTemplateCustomizer from './question_template_customizer';
import ScoringAnswerSync from './scoring_answer_sync';

// hacky mode accomplished
const AdditionalQuestionStyles = styled.div`
  vertical-align: bottom;
  margin-bottom: 15px;

  .Mui-error {
    padding-top: 15px;
  }
`;

AdditionalQuestionStyles.QuestionPrompt = styled.div`
  margin-bottom: 1em;
`;

const AdditionalQuestionRenderer = ({ choice }) => (
  <AdditionalQuestionStyles className="question">
    <Field
      key={choice.get('id')}
      name={`surveyQuestionAttributes.${choice.get('id')}.isAdditional`}
      component={({ input: { value, onChange } }) => {
        if (value !== 'Yes') {
          onChange('Yes');
        }
        return null;
      }}
    />
    {choice.get('setupPrompt') && <AdditionalQuestionStyles.QuestionPrompt>{choice.get('setupPrompt')}:</AdditionalQuestionStyles.QuestionPrompt>}
    <QuestionTemplateCustomizer
      namespace={`surveyQuestionAttributes.${choice.get('id')}.extra.questionPlaceholders`}
      placeholders={choice.getIn(['extra', 'setupQuestionPlaceholders'])}
      question={choice.get('setupQuestion')}
    />
    {choice.getIn(['scoringPolicy', 'scoringAnswerSource']) && <ScoringAnswerSync choice={choice} />}
    <Grid item xs={10}>
      <Field name={`surveyQuestionAttributes.${choice.get('id')}.isIncluded`} component={MuiRadioGroup}>
        <FormGroup row>
          {List(['Yes', 'No']).map((option) => (
            <FormControlLabel key={option} value={option} control={<Radio color="primary" />} label={option} labelPlacement="end" />
          ))}
        </FormGroup>
      </Field>
    </Grid>
  </AdditionalQuestionStyles>
);
AdditionalQuestionRenderer.propTypes = {
  choice: PropTypes.instanceOf(Map).isRequired,
};

const AdditionalSection = ({ choices }) => (
  <Fragment>
    <h4>Additional Screening Questions</h4>
    {choices.map((choice) => (
      <AdditionalQuestionRenderer key={choice.get('id')} choice={choice} />
    ))}
  </Fragment>
);
AdditionalSection.propTypes = {
  choices: PropTypes.instanceOf(List).isRequired,
};

export default AdditionalSection;
